import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Tag from "../Tag/Tag.js";
import './Header.css';/* empty css            */
const HeaderMarkers = ({ markers }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-header-markers"), children: markers.map(({ label, key, color, backgroundColor, borderColor }) => /* @__PURE__ */ jsx(
    Tag,
    {
      color,
      backgroundColor,
      borderColor,
      className: classnames("perxis-auto-header-markers__marker"),
      children: label
    },
    key
  )) });
};
export {
  HeaderMarkers as default
};
//# sourceMappingURL=HeaderMarkers.js.map
